/**
 * Map legacy extraction `suggested_priority` text onto ActionPriority.
 *
 * New extraction emits only low / medium / high. Older items stored
 * unconstrained LLM hints (urgent, P1, …). Use this only when reading that
 * stored hint — not for the action's `priority` field.
 */
import { actionPriorityLabel } from './actionPriority';
import type { ActionPriority } from './types';

const LEGACY_ALIASES: Record<string, ActionPriority> = {
  high: 'high',
  urgent: 'high',
  critical: 'high',
  highest: 'high',
  p1: 'high',
  medium: 'medium',
  moderate: 'medium',
  normal: 'medium',
  standard: 'medium',
  p2: 'medium',
  low: 'low',
  minor: 'low',
  lowest: 'low',
  p3: 'low'
};

export function parseLegacySuggestedPriority(value: string | null | undefined): ActionPriority | null {
  if (!value) return null;
  const normalised = value.trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  if (!normalised) return null;
  if (Object.hasOwn(LEGACY_ALIASES, normalised)) return LEGACY_ALIASES[normalised];
  for (const token of normalised.split(' ')) {
    if (Object.hasOwn(LEGACY_ALIASES, token)) return LEGACY_ALIASES[token];
  }
  return null;
}

export function formatSuggestedPriority(value: string | null | undefined): string {
  if (!value?.trim()) return '';
  const parsed = parseLegacySuggestedPriority(value);
  if (parsed) return actionPriorityLabel(parsed);
  return value
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
